module.exports = {
    API: window.location.hostname === 'localhost' ? 'http://localhost:4001' : window.location.origin,
    SITE_URL: window.location.origin || "http://137.184.48.90:3001",
    AUTH_PATH: '/auth',
    API_PATH: '/api',
    EMAIL: "dev@abdullh.tech"

}
console.log(window.location.hostname)
